var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnZendesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icn-zendesk_svg__clip0_6832_6573)",
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.494 20 0 15.506 0 10S4.494 0 10 0s10 4.494 10 10-4.494 10-10 10zm0-18.828c-4.868 0-8.828 3.96-8.828 8.828 0 4.868 3.96 8.828 8.828 8.828 4.868 0 8.828-3.96 8.828-8.828 0-4.868-3.96-8.828-8.828-8.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.93a.586.586 0 01-.586-.586v-.627a2.94 2.94 0 011.465-2.538A1.76 1.76 0 0010 5.9a1.76 1.76 0 00-1.758 1.757.586.586 0 01-1.172 0A2.933 2.933 0 0110 4.726a2.933 2.933 0 012.93 2.93 2.94 2.94 0 01-1.465 2.538c-.542.313-.88.897-.88 1.523v.627a.586.586 0 01-.585.586zM10 15.273a.586.586 0 100-1.171.586.586 0 000 1.171z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icn-zendesk_svg__clip0_6832_6573"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgIcnZendesk;